/**
 * Generate a consistent hash (0-4) for the initials string.
 *  - This is used to determine which background color to use for the avatar.
 */
function hashCode(str) {
  let hash = 0;
  if (str.length === 0) {
    return hash;
  }
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash % 5);
}

const colorClasses = [
  "bg-purple-200 text-purple-700",
  "bg-yellow-200 text-yellow-800",
  "bg-blue-200 text-blue-700",
  "bg-green-200 text-green-700",
  "bg-red-200 text-red-700"
];

export default config => ({
  loaded: false,
  initials: "",
  imageUrl: config && config.imageUrl ? config.imageUrl : "",
  name: config && config.name ? config.name : "",
  colorClasses: config && config.colorClasses ? config.colorClasses : null,
  init() {
    if (!this.colorClasses) {
      this.colorClasses = colorClasses[hashCode(this.name)];
    }

    const nameArr = this.name.toUpperCase().split(" ");
    const firstName = nameArr[0].charAt(0);
    const lastName = nameArr[1];

    if (nameArr.length > 1) {
      this.initials = firstName + lastName.charAt(0);
    } else {
      this.initials = firstName;
    }
  },
  imageLoaded() {
    this.loaded = true;
  }
});
